export default {"src":"/_next/static/media/maintaining-privacy-program.4561bf97.svg","height":868,"width":868,"blurWidth":0,"blurHeight":0};